import styled from 'styled-components';
import DeviceScreenMaxWidth from '../../common/helpers/deviceScreenSizeHelper';

export const StyledContainerDiv = styled.div`
  width: 100%;
  max-width: 500px;
  margin: clamp(1rem, 5vw, 3.125rem);
  background: ${props => props.theme.colors.greyScale.white};
  border-radius: 16px;
  filter: drop-shadow(0px 3px 14px rgba(78, 71, 69, 0.3));
  padding: 2.5rem clamp(2rem, 15vw, 5rem);
  font-size: 16px;
  box-sizing: border-box;

  @media screen and (max-width: ${DeviceScreenMaxWidth.mobile}) {
    margin: 0;
    border-radius: 0;
    filter: none;
  }
`;

export const StyledInlineTitle = styled.p`
  margin-bottom: 5px;
  font-weight: ${props => props.theme.font.weights.semibold};
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 32px;

  button {
    padding: 10px 24px;
  }

  @media screen and (max-width: ${DeviceScreenMaxWidth.mobile}) {
    button {
      width: 100%;
    }
  }
`;

export const StyledParagraph = styled.p`
  margin-bottom: clamp(1rem, 6.4vw, 2rem);
  word-wrap: break-word;
`;

export const StyledLowMarginParagraph = styled(StyledParagraph)`
  margin-bottom: clamp(0.75rem, 3.2vw, 1rem);
`;
